import axios from "axios";
import { auth } from "@/lib/firebase";

// In dev (`vite dev`) we hit `/api/v1/...` and the Vite server proxies
// those to the backend (see vite.config.ts). In production the static
// admin SPA is hosted on Firebase Hosting at a different origin from
// the API, so VITE_API_URL is injected at build time
// (e.g. https://api-staging.elitemind.co.uk) and we prepend it.
const baseURL = import.meta.env.VITE_API_URL ? `${import.meta.env.VITE_API_URL}/api/v1` : "/api/v1";

const apiClient = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Attach Firebase ID token to every request
apiClient.interceptors.request.use(async (config) => {
  const user = auth.currentUser;
  if (user) {
    const token = await user.getIdToken();
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default apiClient;
